<template>
  <footer class="footer">
    <div class="text-center text-white">
      &copy; Copyright {{ (new Date()).getFullYear() }} Fivenomics. All Rights Reserved
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
  .footer {
    min-height: 32px;
    font-size: 0.8rem;
    font-family: 'C';
    padding-top: .4rem;
    padding-bottom: .4rem;
    margin-top: 3rem;
  }
</style>
